<template>
  <div>
    <v-divider />
    <v-toolbar flat>
      <v-btn icon color="primary" class="mr-3" @click="$emit('FooterRefresh')">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <span class="font-italic mr-2">
        Page {{ footerPagination.page }} of
        {{ Math.max(footerPagination.pageCount, 1) }}, Total results
        {{ footerPagination.itemsLength }}
      </span>
      <v-spacer></v-spacer>

      <v-btn
        text
        small
        color="primary"
        :disabled="footerPagination.page == 1 || loading"
        @click="footerPagination.page--"
      >
        <v-icon left>mdi-chevron-left</v-icon> Previous
      </v-btn>

      <v-btn
        text
        small
        color="primary"
        :disabled="
          footerPagination.page >= footerPagination.pageCount || loading
        "
        @click="footerPagination.page++"
      >
        Next <v-icon right>mdi-chevron-right</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>
  
<script>
export default {
  name: 'DataTableFooter',
  props: {
    footerPagination: {default: null},
    loading: {default: false}
  },
  watch: {
    "footerPagination.page": {
      handler: function(val){
        this.$emit('updatePage',val)
      }
    },
  }
}
</script>
  
  <style lang="scss" scoped>
  </style>